function getAllocationGroupId(line) {
  return line?.allocation_group_id ?? line?.meta?.allocation_group_id ?? null;
}

function sumNumeric(lines, getter) {
  return lines.reduce((sum, line) => {
    const value = Number(getter(line));
    return sum + (Number.isFinite(value) ? value : 0);
  }, 0);
}

/**
 * Merge split fulfillment lines that share allocation_group_id for display.
 * Preserves original per-lot rows on `_groupLines`.
 */
export function groupOrderLinesForDisplay(lineItems) {
  if (!Array.isArray(lineItems) || lineItems.length === 0) return [];

  const seenGroups = new Set();
  const grouped = [];

  for (const line of lineItems) {
    const groupId = getAllocationGroupId(line);
    if (!groupId) {
      grouped.push({ ...line, _groupLines: [line] });
      continue;
    }
    if (seenGroups.has(groupId)) continue;
    seenGroups.add(groupId);

    const lines = lineItems.filter(
      (item) => getAllocationGroupId(item) === groupId,
    );
    if (lines.length === 1) {
      grouped.push({ ...lines[0], _groupLines: lines });
      continue;
    }

    const primary =
      lines.find((item) => Number(item.allocation_index) === 0) ?? lines[0];

    grouped.push({
      ...primary,
      id: primary.id,
      quantity: sumNumeric(lines, (l) => l.quantity),
      original_quantity: sumNumeric(
        lines,
        (l) => l.original_quantity ?? l.quantity,
      ),
      shipped_quantity: sumNumeric(lines, (l) => l.shipped_quantity),
      remaining_to_ship: sumNumeric(lines, (l) => l.remaining_to_ship),
      remaining_quantity: sumNumeric(lines, (l) => l.remaining_quantity),
      total_price: sumNumeric(lines, (l) => l.total_price),
      discount_value: sumNumeric(lines, (l) => l.discount_value),
      _groupLines: lines,
      _isAllocationGroup: true,
    });
  }

  return grouped;
}
